import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=2451cff0&scoped=true"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"
import style0 from "./Pager.vue?vue&type=style&index=0&id=2451cff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451cff0",
  null
  
)

export default component.exports